import { InjectionToken } from '@angular/core';

/** Injection token that can be used to specify UserSettingsService. */
export const USER_SETTINGS_SERVICE = new InjectionToken('UserSettingsService');